import { DraggableProvided } from "@hello-pangea/dnd";
import React from "react";
import { I, T } from "services/lang/LanguageService";

interface DraggableItemProps {
  item: {
    title: string;
    type?: string;
  };
  provided: DraggableProvided;
  type: ReorderType;
  className?: string;
}

export enum ReorderType {
  TABS = "Tabs",
  GROUPS = "Groups",
  COMPONENTS = "Components",
  UNIVERSAL_TABLE_COLUMNS = "Universal Table Columns",
  DD_MENU_ITEMS = "DD Menu Items",
}

const DraggableItem = ({ item, provided, type, className }: DraggableItemProps) => {
  const renderContent = () => {
    switch (type) {
      case ReorderType.TABS:
        return <div className="p-text-bold">{I(item.title)}</div>;

      case ReorderType.COMPONENTS:
        return (
          <>
            <div className="flex flex-row gap-2">
              <div className="w-6rem font-bold">{T("word.title")}:</div>
              <div>{I(item.title) || T("word.untitled-component")}</div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="w-6rem font-bold">{T("word.type")}:</div>
              <div>{item.type || T("word.untitled-component")}</div>
            </div>
          </>
        );

      case ReorderType.GROUPS:
        return <div className="p-text-bold">{I(item.title ?? "") || T("word.untitled-group")}</div>;

      case ReorderType.UNIVERSAL_TABLE_COLUMNS:
        return <div className="p-text-bold">{I(item.title)}</div>;

      case ReorderType.DD_MENU_ITEMS:
        return <div className={className}>{I(item.title)}</div>;

      default:
        return null;
    }
  };

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className="flex flex-column border-round p-3 p-shadow-2 p-mb-3"
      style={{ ...provided.draggableProps.style, cursor: "grab" }}
    >
      {renderContent()}
    </div>
  );
};

export default DraggableItem;
